import React, { useState, useRef, useEffect, FormEvent } from 'react';
import emailjs from '@emailjs/browser';
import { t } from 'i18next';

function ContactForm (){
  const emailRef = useRef<HTMLInputElement>(null);
  const nameRef = useRef<HTMLInputElement>(null);
  const subjectRef = useRef<HTMLInputElement>(null);
  const messageRef = useRef<HTMLTextAreaElement>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => emailjs.init("d7Kkjhbe6p_mr3WuQ"), []);
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const serviceId = "service_48n817v";
    const templateId = "template_ym0tqpq";
    try {
      setLoading(true);
      await emailjs.send(serviceId, templateId, {
        name: nameRef.current?.value,
        sender: emailRef.current?.value,
        subject: subjectRef.current?.value,
        message: messageRef.current?.value
      });
      alert(t("contactForm.alert"));
      if (nameRef.current) nameRef.current.value = '';
      if (emailRef.current) emailRef.current.value = '';
      if (subjectRef.current) subjectRef.current.value = '';
      if (messageRef.current) messageRef.current.value = '';
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact1">
      <form className="contact1-form validate-form" onSubmit={handleSubmit}>
        <span className="contact1-form-title">
          {t("contactForm.title")}
        </span>

        <div className="wrap-input1 validate-input" data-validate = {t("contactForm.validate.name")}>
          <input required ref={nameRef} className="input1" type="text" name="name" placeholder={t("contactForm.name")} />
          <span className="shadow-input1"></span>
        </div>

        <div className="wrap-input1 validate-input" data-validate = {t("contactForm.validate.email")}>
          <input required ref={emailRef} className="input1" type="text" name="email" placeholder={t("contactForm.email")} />
          <span className="shadow-input1"></span>
        </div>

        <div className="wrap-input1 validate-input" data-validate = {t("contactForm.validate.subject")}>
          <input required ref={subjectRef} className="input1" type="text" name="subject" placeholder={t("contactForm.subject")} />
          <span className="shadow-input1"></span>
        </div>

        <div className="wrap-input1 validate-input" data-validate = {t("contactForm.validate.message")}>
          <textarea required ref={messageRef} className="input1" name="message" placeholder={t("contactForm.message")}></textarea>
          <span className="shadow-input1"></span>
        </div>

        <div className="container-contact1-form-btn">
          <button type='submit' className="contact1-form-btn" disabled={loading}>
            <span>
              {t("contactForm.send")}
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
            </span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;